// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1Qx5R","options":"AnswerScale_options__1r3fA","selected":"AnswerScale_selected__1rqz_"};